module.exports = __webpack_public_path__ + "static/media/plezus.7514fe54.png";